import {
  Box,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
} from '@mui/material'
import { RetailerAccount } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'
import { useSelector } from 'react-redux'
import { makeStyles } from 'tss-react/mui'

import analytics from '@src/analytics'
import { currentRetailerAccountSelector } from '@src/stores/app/selectors'
import InstagramIcon from '@src/svgs/legacy/instagram.svg?react'

const useStyles = makeStyles()((theme) => ({
  dialogTitle: {
    textAlign: 'center',
  },
  igIconSpacer: {
    marginTop: theme.spacing(13),
  },
}))

const IGDesktopSetup: React.FC<
  React.PropsWithChildren<{ retailerId: string }>
> = ({ retailerId }) => {
  const currentRetailerAccount: RetailerAccount = useSelector(
    currentRetailerAccountSelector,
  )

  const { classes } = useStyles()
  return (
    <Box textAlign="center">
      <Box margin={1}>
        <InstagramIcon height="3.9em" className={classes.igIconSpacer} />
        <DialogTitle>{I18n.t('igAutoShare.turnOnIgDesktop')}</DialogTitle>
      </Box>

      <DialogContent>
        <DialogContentText variant="body1">
          <Link
            href="https://support.promoboxx.com/hc/en-us/articles/15363080988443-Connecting-your-Instagram-to-your-Facebook-for-Direct-Posting"
            target="_blank"
            onClick={() =>
              analytics.track({
                event: 'Click',
                type: 'Clicked on Article on how to setup Desktop Auto share',
                data: {
                  feature: 'IG Auto Share',
                  retailer_account_id: currentRetailerAccount.id,
                  retailer_id: retailerId,
                },
              })
            }
          >
            {I18n.t('igAutoShare.clickHereToLearnHow')}
          </Link>
        </DialogContentText>
      </DialogContent>
    </Box>
  )
}

export default IGDesktopSetup
